import { createFileRoute } from '@tanstack/react-router'
import { NewQuotePage } from '@/features/quote-builder/start/new-quote-page'

export const Route = createFileRoute('/_authenticated/quotes/new')({
  staticData: { title: 'New Quote' },
  component: NewQuotePage,
})
